module.exports = __webpack_public_path__ + "static/about-insta-1@2x-3aed7c9505ebbed1744ad83803b2e2c7.jpg";